import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Loader = ({ isDarkTheme }) => {
  return (
    <div
      className={classNames(
        'loader',
        { 'loader-dark ': !isDarkTheme },
        { 'loader-white': isDarkTheme },
      )}
    >
      Loading...
    </div>
  );
};

Loader.propTypes = {
  isDarkTheme: PropTypes.bool,
};

export default Loader;
